import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SuiContainer } from '@splashthat/sui';

import { getEditFormNodeId } from 'common/compounds/FormBuilder/selectors';
import { getFormNode } from 'common/entities/formNode/selectors';
import { NODE_NAME_UTM_PARAMS } from 'common/entities/formNode/nodeNames';
import UtmParamsControl from './components/UtmParamsControl';
import LabelControl from './components/LabelControl';

const GROUP_NAME_LABEL = 'Group Name';
const BASE_CLASS_NAME = 'FormEditorEditGroup';

class FormEditorEditGroup extends Component {
    static propTypes = {
        formNodeId: PropTypes.string.isRequired,
        name: PropTypes.string,
    };

    static defaultProps = {
        name: '',
    };

    render() {
        const { formNodeId, name } = this.props;

        return (
            <SuiContainer variation="flex-vertical">
                <SuiContainer className={`${BASE_CLASS_NAME}__content`}>
                    <LabelControl formNodeId={formNodeId} inputLabel={GROUP_NAME_LABEL} />

                    {name === NODE_NAME_UTM_PARAMS && <UtmParamsControl formNodeId={formNodeId} />}
                </SuiContainer>
            </SuiContainer>
        );
    }
}

const mapStateToProps = (state) => {
    const formNodeId = getEditFormNodeId(state);
    const formNode = getFormNode(state, formNodeId);

    return {
        formNodeId,
        name: formNode ? formNode.name : undefined,
    };
};

export default connect(mapStateToProps)(FormEditorEditGroup);
